// Shared due-date bucketing for the summary banners. Mirrors the worker's
// debt/receivable summary logic (apps/worker/src/routes/{licenses,invoices}.ts)
// exactly, so clicking a period chip filters the table down to precisely the
// rows that make up that figure: overdue → ≤7 → ≤14 → ≤30 → later, where the
// windows are disjoint (a row in ≤14 is 8–14 days out, not 0–14) and a missing
// due date counts as "later".
export type DuePeriod = 'overdue' | 'w7' | 'w14' | 'w30' | 'later'

export function classifyDuePeriod(date: string | null, today: string): DuePeriod {
  if (!date) return 'later'
  const days = Math.round((new Date(date).getTime() - new Date(today).getTime()) / 86400000)
  if (days < 0) return 'overdue'
  if (days <= 7) return 'w7'
  if (days <= 14) return 'w14'
  if (days <= 30) return 'w30'
  return 'later'
}

// The period key a within-N bucket chip carries (7 → 'w7', 14 → 'w14', …).
export function bucketPeriod(within: number): DuePeriod {
  return `w${within}` as DuePeriod
}
